import React from "react";
import { Star } from "@phosphor-icons/react";
import { STATS, STATS_SECTION } from "../../data/startPageContent";
import useStartReveal from "./useStartReveal";
import StartShapes from "./StartShapes";
import "./StartSections.css";

const isLatin = (s) => /^[\d.+/\s]*$/.test(s || "");

/** Stats strip (plan §4.4) — dark band, soft animated shapes, per-item accent. */
export default function StartStats() {
  const ref = useStartReveal();
  return (
    <section id="start-stats" className="st-section st-stats st-dark" aria-label="נתוני המערכת">
      <StartShapes prefix="st-stats" />
      <div className="st-container st-reveal" ref={ref}>
        <p className="st-stats-title">{STATS_SECTION.title}</p>
        <div className="st-stats-grid">
          {STATS.map((s) => {
            const latinSuffix = isLatin(s.suffix);
            return (
              <div key={s.key} className={`st-stats-item st-stats-item--${s.key}`}>
                <span className="st-stats-value">
                  {s.stars && <Star size={22} weight="fill" aria-hidden="true" className="st-stats-star" />}
                  <span dir="ltr" className="st-stats-num">
                    {s.prefix}
                    {s.value}
                    {latinSuffix ? s.suffix : null}
                  </span>
                  {!latinSuffix && <span className="st-stats-unit">{s.suffix}</span>}
                </span>
                <span className="st-stats-label">{s.label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
